import axios from "axios";
export const state = {
    fyears: [],
    revprojection: [],
    expprojection: [],
    save_status: false,
};
export const getters = {
    FinancialYears: state => state.fyears.data,
    RevenueProjection: state => state.revprojection,
    ExpenseProjection: state => state.expprojection,
    SaveStatus: state => state.save_status,
};

export const mutations = {
    SET_FYEARS(state, newValue) {
        state.fyears = newValue
    },
    SET_INCOME_PROJECTION(state, newValue) {
        state.revprojection = newValue
    },
    SET_EXPENSE_PROJECTION(state, newValue) {
        state.expprojection = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
   
};

export const actions = {
    addFinancialYear({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('fyears',payload).then(() => {
            dispatch('fetchFyears');
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },
    // Edit  Set
    editFinancialYear({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`fyears/${payload.id}`, payload).then(() => {
            dispatch('fetchFyears');
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },
    // Delete Set
    deleteFinancialYear({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`fyears/${payload.id}`).then(() => {
            dispatch('fetchFyears');
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },

    addIncomeProjection({ commit },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('revenue_projections',payload).then(() => {
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },
    addExpenseProjection({ commit },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('expense_projections',payload).then(() => {
            commit('SET_SAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },

    fetchFyears({ commit }) {
        axios.get('fyears').then(pos => {
            commit('SET_FYEARS', pos.data)
        })
    },
    fetchRevProjection({ commit }, payload) {
        axios.post('view_revenue_projections', payload).then(sta => {
            commit('SET_INCOME_PROJECTION', sta.data)
        })
    },
    fetchExpProjection({ commit }, payload) {
        axios.post('view_expense_projections', payload).then(sta => {
            commit('SET_EXPENSE_PROJECTION', sta.data)
        })
    },
};